import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = n => (_pushScopeId("data-v-74763da4"), n = n(), _popScopeId(), n);
var _hoisted_1 = {
  class: "app-wrapper"
};
import Main from './Main.vue';
var __default__ = {
  name: 'IndexLayout'
};
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Main)]);
    };
  }
});